module.exports = __webpack_public_path__ + "/content/skins/acme/fonts/AcmeUnica77TT-Medium.ttf";